import axios from 'axios'
import qs from 'qs'

/**
 * Persist the account text-processing language. Mirrors the Settings page's
 * saveLanguageSettings routine (views/react/home/Settings.jsx): POST /settings
 * accepts partial form-encoded bodies, so sending only `inlanguage` is safe.
 */
export async function postUserLanguage(inlanguage) {
    const response = await axios.post('/settings', qs.stringify({ inlanguage }), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    })
    return response.data
}
